import * as Dialog from '@radix-ui/react-dialog';
import { twMerge } from 'tailwind-merge';

export type TitleProps = Dialog.DialogTitleProps;

export function Title({ className, ...props }: TitleProps) {
  return <Dialog.Title {...props} className={twMerge('sr-only', className)} />;
}
